// extracted by mini-css-extract-plugin
export default {"CallToAction__Section":"CallToAction_CallToAction__Section__ptqzO","Card":"CallToAction_Card__bOC98","Title":"CallToAction_Title__Tx7BU"};